export default `
    <div class="action-button-container #= data.bsc || "" ## if (data.hidden) { #hidden# } #">
        <button # if (data.disabled) { # disabled # } # class="action-button #= data.dropdownItems ? "action-button-dropdown" : "" # #= data.classes || "" # # if (data.disabled) { # disabled # } # " id="#= data.id #"
            # if (data.toolTip) { # title="#= data.toolTip #" # } #
        >
            <span class="button-warning-icon">
                <i class="fas fa-exclamation"></i>
            </span>
            <span class="text-container">
                <span class="success">
                </span>
                <span class="fail">
                </span>
                <span class="text bind-label" data-bind="text: #= data.label #" data-label-for-id="#= data.id #">
                </span>
                # if (data.showBadge) { #
                    <span class="button-badge badge">
                        #= data.badgeCount #
                    </span>
                # } #
            </span>
            # if (!data.dropdownItems) { #
                <span class="spinner" />
            # } #
        </button>
        # if (data.dropdownItems) { #
            <div class="button-dropdown-container">
                <button # if (data.disabled) { # disabled # } # class="button-dropdown #= data.classes || "" # # if (data.disabled) { # disabled # } #">
                    <i class="dropdown-icon fa fa-caret-down"></i>
                    # if (data.dropdownItems) { #
                        <span class="spinner" />
                    # } #
                </button>
                <ul class="button-dropdown-content" role="menu" />
            </div>
        # } #
    </div>
`;
